// Services.js
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Nav, Modal, Button } from "react-bootstrap";
import authToken from "./../token/Token";
import { servicesApi } from "./../API/api";

const Services = () => {
  const [empdata, empdatachange] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const history = useHistory();

  const LoadEdit = (service_id) => {
    history.push("/updates/edit_services/" + service_id);
  };

  const handleDelete = (service_id) => {
    setDeleteItemId(service_id);
  };

  const confirmDelete = () => {
    fetch(`${servicesApi}/${deleteItemId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      })
      .then((data) => {
        console.log("Delete successful:", data);
        fetchData();
      })
      .catch((error) => {
        console.error("Error deleting data:", error.message);
      })
      .finally(() => {
        setDeleteItemId(null);
      });
  };

  const handleClose = () => {
    setDeleteItemId(null);
  };

  const fetchData = () => {
    fetch(servicesApi)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      })
      .then((resp) => {
        console.log("API Response:", resp);

        const data = Array.isArray(resp) ? resp : resp.data || [];

        empdatachange(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching data:", err.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <section className="wrap-section-1">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 bg-white">
            <div className="d-flex">
              <h3 className="fw-bold">Services</h3>
              <a href="#!" className="btn btn-warning ms-auto text-white">
                <Nav.Link as={Link} to="/creates/create_services">
                  Tambah data
                </Nav.Link>
              </a>
            </div>

            <div className="row pt-4">
              {loading ? (
                <p>Loading...</p>
              ) : empdata.length > 0 ? (
                empdata.map((item) => (
                  <div
                    className="col-lg-12 shadow-sm p-3 mb-3 bg-body-tertiary rounded"
                    key={item.service_id}
                  >
                    <div className="row">
                      <div className="col-md-3 ps-4">
                        <p>services_title</p>
                        <h5 className="ps-2">{item.service_name}</h5>
                      </div>
                      <div className="col-md-3 ps-4">
                        <p>services_icon</p>
                        <h5 className="ps-2">
                          {item.icon_url && (
                            <img
                              src={item.icon_url}
                              alt={item.service_name}
                              height="50rem"
                            />
                          )}
                        </h5>
                      </div>
                      <div className="col-md-3 ps-4">
                        <p>services_link</p>
                        <h5 className="ps-2">{item.service_url}</h5>
                      </div>
                      <div className="col-md-3 ps-4">
                        <p>services_action</p>
                        <div className="d-flex ps-2">
                          <button
                            onClick={() => {
                              LoadEdit(item.service_id);
                            }}
                            className="btn btn-warning"
                          >
                            <i className="bi bi-pencil-square"></i> Edit
                          </button>
                          <button
                            onClick={() => {
                              handleDelete(item.service_id);
                            }}
                            className="btn btn-danger ms-2"
                          >
                            <i className="bi bi-trash"></i> Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No data available</p>
              )}
            </div>

            <Modal show={deleteItemId !== null} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Confirm Delete</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Apakah Anda yakin ingin menghapus data ini?
              </Modal.Body>
              <Modal.Footer>
                <Button variant="danger" onClick={confirmDelete}>
                  Ya, hapus
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                  Tidak
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
